import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class UpdateEnclosureCardErrorAction implements Action {
  public static readonly type = 'UpdateEnclosureCardErrorAction';

  constructor(public error: BijbError) {
  }

  public type = UpdateEnclosureCardErrorAction.type;
}
